import { IsFlexActionTypes, SET_IS_FLEX } from '../actions/isFlexActionTypes';

const isFlex = (state = false, action: IsFlexActionTypes): boolean => {
	if (action.type === SET_IS_FLEX) {
		return action.payload;
	}
	return state;
};

export default isFlex;
